import { useQuery } from "@tanstack/react-query";
import { getLeatMappings } from "../../api/bLeatApi";

export const useGetLeatMappings = (organisationId) => {
  return useQuery({
    queryKey: ["leat-mappings", organisationId],
    queryFn: () => getLeatMappings(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    onError: (error) => {
      console.error("Error fetching Leat mappings:", error.response || error);
    },
  });
};
